module.exports = __webpack_public_path__ + "img/people-pants-simple.146a737b.svg";